<template>
  <div class="ma3 ma4-l mb4">
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>

    <async-component :asyncFunction="loadDocumentTemplate" #default="{ loading, error }">
      <content-spinner v-if="loading" class="mv4"/>
      <div v-else-if="error" class="mv4">Ошибка: {{ error }}</div>
      <div v-else>
        <div class="border pb2 b lh-copy text-primary">
          Параметры шаблона "по умолчанию"
        </div>

        <!--
        <div class="section-layout border pv3">
          <div class="section-title text-primary ttu">Имя шаблона</div>
          <div class="section-data b">{{ title }}</div>
        </div>
        -->

        <div class="horizontal-input-layout pv3 border">
          <span class="horizontal-input-label ttu text-secondary">Шаблон:</span>
          <input class="text-input bg-middle horizontal-input-data data-layout b" type="text" v-model="title">
          <!--
          <span style="color: red" class="horizontal-input-error">{{ e }}</span>
          -->
        </div>

        <fields-form v-model="formFields" class="mt3"/>

        <div class="section-layout mt4">
          <div class="section-title"></div>
          <div class="section-data">
            <action-button title="Сохранить" :loading="saving" @click="saveFields" :disabled="!changed"/>
          </div>
        </div>
      </div>
    </async-component>
  </div>
</template>

<script>
import NavBackToList from '@/components/common/NavBackToList.vue'
import AsyncComponent from '@/components/AsyncComponent.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import FieldsForm from '@/components/document_templates/FieldsForm.vue'
import ActionButton from '@/components/ui/Button.vue'
import { DataService } from '@/services/DataService.js'

export default {
  components: {
    NavBackToList,
    AsyncComponent,
    ContentSpinner,
    FieldsForm,
    ActionButton
  },
  props: ['id'],
  data () {
    return {
      title: null,
      fields: [],
      changed: false,
      saving: false
    }
  },
  computed: {
    formFields: {
      get () { return this.fields },
      set (fields) {
        this.fields = fields
        this.changed = true
      }
    }
  },
  methods: {
    loadDocumentTemplate () {
      return DataService.getDocumentTemplates({ filter: { id: +this.id }, limit: 1, offset: 0 })
        .then(({ data: { documentTemplates: { data } } }) => {
          if (!data.length) return
          if (!data[0].fields) return
          this.title = data[0].title
          this.fields = data[0].fields.map(({ key, value }) => [key, value])
        })
    },
    async saveFields () {
      const fields = this.fields.filter(([_k, v]) => !(v === null || v === undefined)).map(([key, value]) => ({ key, value: `${value}` }))

      this.saving = true
      return DataService.updateDocumentTemplate({ templateId: +this.id, title: this.title, fields })
        .then(({ data: { updateDocumentTemplate: { id, title, fields } } }) => {
          this.$store.dispatch('notification/add', {
            title: 'Шаблон сохранен',
            type: 'info'
          })
          this.changed = false
        })
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
          this.$store.dispatch('notification/add', {
            title: 'Произошла ошибка. Проверьте параметры.',
            type: 'info'
          })
        })
        .finally(() => {
          this.saving = false
        })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.changed) {
      if (window.confirm('Есть несохраненные изменения! Все равно покинуть страницу?')) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
.section-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto auto;
  align-items: end;
}
.section-title {
  justify-self: end;
  padding-right: .5rem;
}
.section-data {
  justify-self: start;
}
.border {
  border-bottom-style: solid;
  border-bottom-width: .1rem;
  border-color: #F0F4F8
}
</style>
